var map = {
	"./de/btn-back.png": "DGXm",
	"./en/btn-back.png": "+e3w",
	"./es/btn-back.png": "wc2G",
	"./fr/btn-back.png": "I93w",
	"./ja/btn-back.png": "Q1rI",
	"./ko/btn-back.png": "G3rE",
	"./pt/btn-back.png": "f9wm",
	"./ru/btn-back.png": "SgBp",
	"./th/btn-back.png": "7MiD",
	"./zh-Hant/btn-back.png": "WtLU"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31d0";